import { useEffect, useRef, useState } from "react";

// Lightweight scroll-reveal hook: adds `reveal-visible` once the element
// enters the viewport. Respects prefers-reduced-motion (CSS handles that
// fallback by keeping opacity:1 unconditionally in that media query).
export const useReveal = (options = {}) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(node);
        }
      },
      { threshold: 0.15, ...options }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [ref]); // eslint-disable-line react-hooks/exhaustive-deps

  return [ref, visible];
};
